import {action} from 'typesafe-actions'
import {ILogin} from '../../services/api/login'
import {CodeActionTypes} from './types'

export const FetchLoginAction = (data: ILogin) => action(CodeActionTypes.FETCH_LOGIN, data)
export const SetLoginAction = (data: any) => action(CodeActionTypes.SET_LOGIN, data)
export const FetchError = () => action(CodeActionTypes.FETCH_ERROR)
